
import { getDriversInBranchArea, setIsListView } from "../../features/branchUserLocations/branchUserLocationsSlice"
import styled from "styled-components"
import { GoogleMap, Polygon } from "@react-google-maps/api"
import { useSelector, useDispatch } from "react-redux"
import { useCallback, useEffect, useRef } from "react"
import UserLocations from "../../components/branchBoundaries/UserLocations"
import UserOverlay from "../../components/branchBoundaries/UserOverlay"
import CustomInfoWindow from "../../components/branchBoundaries/CustomInfoWindow"
import AbsoluteSpinner from "../../components/shared/spinners/AbsoluteSpinner"
import UserList from "../../components/branchBoundaries/UserList"
import { BiSolidRightArrow, BiSolidLeftArrow } from "react-icons/bi";

const Container = styled.div`
  width: calc(100vw - 80px);
  height: 100vh;
  position: relative;

   .btn-wrapper{
      position: absolute;
      top: 10px;
      right: 60px;

      .filter-btn{
        background-color: ${({theme}) => theme.mainBgColor};
        padding: 0 20px;
        display: flex;
        align-items: center;
        gap: 5px;
        border-radius: 10px;
        height: 40px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-xl);
        color: ${({theme}) => theme.mainTextColor};

        .arr-left{
          font-size: 1.2rem;
          color: #888;
        }
      }
  }
`

  const options = {
    strokeColor: '#EE4C3D',
    strokeWeight: 4,
    fillColor: '#ff00004b',
  };

function getCenterAndTopCenter(points, offset = 0.0000) {
  if (!points || points.length === 0) return null;

  // Ortalama lat lng (merkez)
  const center = points.reduce(
    (acc, p) => {
      acc.latSum += p.latitude;
      acc.lngSum += p.longitude;
      return acc;
    },
    { latSum: 0, lngSum: 0 }
  );

  const centerLat = center.latSum / points.length;
  const centerLng = center.lngSum / points.length;

  // En yüksek latitude değeri (polygonun en üst sınırı)
  const maxLatitude = points.reduce(
    (max, p) => (p.latitude > max ? p.latitude : max),
    points[0].latitude
  );

  // Merkezin longitude'su ile en üst latitude birleşimi = merkez noktasının tam üstü
  const topCenter = {
    lat: maxLatitude + offset,
    lng: centerLng,
  };

  return {
    center: { lat: centerLat, lng: centerLng },
    topCenter,
  };
}

  

const BranchDriverLocation = () => {

    const {branchList, isLoadingGetDriversInBranchArea, isListView, filterDurationHour} = useSelector(state => state.branchUserLocations)

    
    const mapRef = useRef(null);
  const hoverTimeout = useRef()
  const mapContainerRef = useRef(null);


    const dispatch = useDispatch()

    useEffect(() => {
      dispatch(getDriversInBranchArea({
        duration: filterDurationHour

      }))
    },[])


    const initialCenterRef = useRef({ lat: 39.419221, lng: 34.343262 });

        const getDynamicWidthContent = useCallback(({regionName, userCount}) => {
  
      if(!regionName){
        return;
      }
      const text1 = regionName;
      const text2 = userCount?.toString();
  
    // Padding değerleri: sol, üst, sağ, alt
    const leftPadding = 12;
    const topPadding = 3;
    const rightPadding = 8;
    const bottomPadding = 8; // Alt padding değeri
    const lineHeight = 18; // Her satırın yüksekliği
  
    // İki satır için en geniş metni baz alarak genişliği hesaplıyoruz.
    const maxLength = Math.max(text1.length, text2.length);
    const width = maxLength * 8 + leftPadding + rightPadding;
    // Yükseklik: üst padding + iki satırın yüksekliği + alt padding
    const height = topPadding + lineHeight * 2 + bottomPadding;
  
      return (
        <div style={{ padding: 0, margin: 0 }}>
          <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
            <rect x="0" y="0" width={width} height={height} rx="8" ry="8" fill="black" />
            <text
              x={leftPadding}
              y={topPadding + lineHeight}
              fontSize="12"
              fill="white"
              fontFamily="Arial"
              textAnchor="start" // Sola yaslı
              fontVariant={"lining-nums"}
            >
            <tspan x={leftPadding} dy="0">{text1}</tspan>
            <tspan x={leftPadding} dy={lineHeight}>{text2} Üye</tspan>
            </text>
          </svg>
        </div>
      );
    }, []);


  return (
    <Container ref={mapContainerRef}>
          <GoogleMap
          center={initialCenterRef.current}
          zoom={6}
                 mapContainerStyle={{
          width: isListView ? "calc(100% - 380px)" : "100%",
          height: "100%",
        }}
        onLoad={(map) => (mapRef.current = map)}

        >
          {
            branchList.map((item, i) => (
               <Polygon
                key={i}
                path={item.branchCoords.$values.map(coordItem => {
                  return {
                    lat: coordItem.latitude,
                    lng: coordItem.longitude
                  }
                })}
                options={options}
                onClick={() => {}}
              />
            ))
          }

                  <div className="btn-wrapper">
                    <button className="filter-btn" onClick={() => dispatch(setIsListView(!isListView))}>
                      {
                        !isListView ? 
                        <>
                          <BiSolidLeftArrow className="arr-left"/>Filtrele/Listele
                        </>
                        :
                        <>
                          Gizle <BiSolidRightArrow className="arr-left"/>
                        </>
                      }
                    </button>
                  </div>

          <UserLocations mapRef={mapRef} mapContainerRef={mapContainerRef} hoverTimeout={hoverTimeout} userLocations={branchList.map(item => item.users.$values).flat()}/>

          <UserOverlay hoverTimeout={hoverTimeout}/>

                  {(isLoadingGetDriversInBranchArea  || branchList.length < 1) && (
          <AbsoluteSpinner size="40px" color="#fff" bgColor="#E85446" />
        )}
          
          {
            branchList.map(item => (
               <CustomInfoWindow
                mapRef={mapRef}
                position={getCenterAndTopCenter(item.branchCoords.$values).topCenter}
                center={getCenterAndTopCenter(item.branchCoords.$values).center}
                content={getDynamicWidthContent({regionName: `${item?.branchName?.name} Şube`, userCount: item?.users?.$values?.length})}
                branchItem={item}
            />
            ))
          }

           
        </GoogleMap>
      {
        isListView &&
        <UserList mapRef={mapRef} mapContainerRef={mapContainerRef} />
      }
    </Container>
  )
}

export default BranchDriverLocation